export default {
  listTimeRange: {
    CONTRIB_1DAY: 'contrib1Day',
    CONTRIB_5DAY: 'contrib5Day',
    CONTRIB_10DAY: 'contrib10Day',
    CONTRIB_20DAY: 'contrib20Day',
  },

  TOP_GAINERS: 'topGainers',
  TOP_LOSERS: 'topLosers',

  listContribution: {
    AVERAGE_VOLUME_1WEEK: 'averageVolume1Week',
    CONTRIBUTION: 'contribution',
    CONTRIBUTION_PERCENT: 'contributionPercent',
    ORGAN_CODE: 'organCode',
    RANK: 'rank',
    MARKET_CAP: 'rtd11',
    TICKER: 'ticker',
    TOTAL_MATCH_VOLUME: 'totalMatchVolume',
    TOTAL_MATCH_VALUE: 'totalMatchValue',
    MATCH_PRICE: 'matchPrice',
    PRICE_CHANGE: 'priceChange',
    PERCENT_PRICE_CHANGE: 'percentPriceChange',
  },

  SERIES: 'series',
  listIndex: {
    COM_GROUP_CODE: 'comGroupCode',
    INDEX_VALUE: 'indexValue',
    TRADING_DATE: 'tradingDate',
    INDEX_CHANGE: 'indexChange',
    PERCENT_INDEX_CHANGE: 'percentIndexChange',
    REFERENCE_INDEX: 'referenceIndex',
    OPEN_INDEX: 'openIndex',
    CLOSE_INDEX: 'closeIndex',
    HIGHEST_INDEX: 'highestIndex',
    LOWEST_INDEX: 'lowestIndex',
    TYPE_INDEX: 'typeIndex',
    TOTAL_MATCH_VOLUME: 'totalMatchVolume',
    TOTAL_MATCH_VALUE: 'totalMatchValue',
    TOTAL_DEAL_VOLUME: 'totalDealVolume',
    TOTAL_DEAL_VALUE: 'totalDealValue',
    TOTAL_VOLUME: 'totalVolume',
    TOTAL_VALUE: 'totalValue',
    TOTAL_STOCK_UP_PRICE: 'totalStockUpPrice',
    TOTAL_STOCK_DOWN_PRICE: 'totalStockDownPrice',
    TOTAL_STOCK_NO_CHANGE_PRICE: 'totalStockNoChangePrice',
    TOTAL_UP_VOLUME: 'totalUpVolume',
    TOTAL_DOWN_VOLUME: 'totalDownVolume',
    TOTAL_NO_CHANGE_VOLUME: 'totalNoChangeVolume',
    TOTAL_TRADE: 'totalTrade',
    FOREIGN_BUY_VALUE_MATCHED: 'foreignBuyValueMatched',
    FOREIGN_BUY_VOLUME_MATCHED: 'foreignBuyVolumeMatched',
    FOREIGN_SELL_VALUE_MATCHED: 'foreignSellValueMatched',
    FOREIGN_SELL_VOLUME_MATCHED: 'foreignSellVolumeMatched',
    FOREIGN_BUY_VALUE_DEAL: 'foreignBuyValueDeal',
    FOREIGN_BUY_VOLUME_DEAL: 'foreignBuyVolumeDeal',
    FOREIGN_SELL_VALUE_DEAL: 'foreignSellValueDeal',
    FOREIGN_SELL_VOLUME_DEAL: 'foreignSellVolumeDeal',
    FOREIGN_BUY_VALUE_TOTAL: 'foreignBuyValueTotal',
    FOREIGN_BUY_VOLUME_TOTAL: 'foreignBuyVolumeTotal',
    FOREIGN_SELL_VALUE_TOTAL: 'foreignSellValueTotal',
    FOREIGN_SELL_VOLUME_TOTAL: 'foreignSellVolumeTotal',
    FOREIGN_TOTAL_ROOM: 'foreignTotalRoom',
    FOREIGN_CURRENT_ROOM: 'foreignCurrentRoom',
    STATUS: 'status',
    TOTAL_STOCK_UNDER_FLOOR: 'totalStockUnderFloor',
    TOTAL_STOCK_OVER_CEILING: 'totalStockOverCeiling',
    MATCH_VOLUME: 'matchVolume',
    MATCH_VALUE: 'matchValue',
    CEILING: 'ceiling',
    FLOOR: 'floor',
  },

  listOrganCodeFilter: [
    'VNINDEX',
    'HNXIndex',
    'UpcomIndex',
    'VN30',
    'HNX30',
    'VNDIAMOND',
    'VNFINSELECT',
    'VNFINLEAD',
  ],

  listFilterByOrganCode: {
    VNINDEX: { key: 'VNINDEX', name: 'HOSE' },
    HNXIndex: { key: 'HNXIndex', name: 'HNX' },
    UpcomIndex: { key: 'UpcomIndex', name: 'UPCOM' },
    VN30: { key: 'VN30', name: 'VN30' },
    HNX30: { key: 'HNX30', name: 'HNX30' },
    VNDIAMOND: { key: 'VNDIAMOND', name: 'VNDIAMOND' },
    VNFINSELECT: { key: 'VNFINSELECT', name: 'VNFINSELECT' },
    VNFINLEAD: { key: 'VNFINLEAD', name: 'VNFINLEAD' },
  },
};
